const PageHeader = ({ title, subtitle = '', actions = null, className = '' }) => {
    return (
        <header className={`flex flex-col gap-3 md:flex-row md:items-end md:justify-between ${className}`}>
            <div className="space-y-1">
                <h1 className="text-2xl md:text-3xl font-bold text-black dark:text-white">{title}</h1>
                {subtitle ? <p className="text-sm md:text-base text-mono-600 dark:text-mono-400">{subtitle}</p> : null}
            </div>
            {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
        </header>
    );
};

export default PageHeader;
